import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPanoramaView: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPanoramaView"><Path d="M1.98878 4.0391L1 3.70703V20.2984L1.9922 19.9599C8.86694 17.6142 15.1331 17.6142 22.0078 19.9599L23 20.2984V3.70703L22.0112 4.0391C15.0958 6.36159 8.90418 6.36159 1.98878 4.0391Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPanoramaView;
